import { Link } from '@tanstack/react-router';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ReportViewMode, localStateKeys } from '../utils/reportviewutils';
import '../styles/main.css';

function ReportSideBar() {
  const { data : viewMode } = useQuery({
    queryKey: localStateKeys.viewMode,
    queryFn: async () : Promise<ReportViewMode> => {
      return Promise.resolve(ReportViewMode.Measurement);
    },
    staleTime: Infinity,
  });

  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (viewMode : ReportViewMode) => {
      return Promise.resolve(viewMode);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(
        localStateKeys.viewMode, data
      )
    },
  });

  // event handler 
  const handleModeButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.currentTarget.dataset.viewMode;
    mutation.mutate(Number(event.currentTarget.dataset.viewMode));
  }

  return (
    <>
      { 
        (() => {
          viewMode;
          console.log('measurement page is now rendering...');
          return null;
        })() && undefined
      }
      <Link to='/' >
        <button>
          <p>Go Back</p>
        </button>
      </Link>       
      <button onClick={handleModeButtonClick} 
              data-view-mode={ReportViewMode.Measurement}>Measurements</button>
      <button onClick={handleModeButtonClick} 
              data-view-mode={ReportViewMode.Findings}>Findings</button>
      <button onClick={handleModeButtonClick} 
              data-view-mode={ReportViewMode.Comment}>Comment</button>
    </>
  )
}

export default ReportSideBar
